import {Autocomplete, type AutocompleteItem} from '@mantine/core';
import type {FC} from 'react';
import {MdSearch} from 'react-icons/md';
import {COLOR_BACKGROUND_1} from '../../../../config/constants/colorCodes';
import {CommonLink} from '../../../../shared/components/CommonLink';

export const CompanyNameSearch: FC<{
  searchWord: string;
  autoCompleteData: AutocompleteItem[];
  isPC: boolean;
  handleSearchInputChange: (searchWord: string) => void;
}> = ({searchWord, autoCompleteData, isPC, handleSearchInputChange}) => {
  return (
    <Autocomplete
      placeholder={'企業名で検索'}
      icon={<MdSearch size="28px" />}
      itemComponent={(props) => (
        <CommonLink
          href={`/company/${props.id}/experiences`}
          className="border-b-2 border-line cursor-pointer flex items-center line-clamp-2 hover:underline text-primary p-4"
        >
          {props.value}
        </CommonLink>
      )}
      data={autoCompleteData}
      value={searchWord}
      onChange={(searchWord) => {
        handleSearchInputChange(searchWord);
      }}
      size="sm"
      dropdownPosition="bottom"
      limit={1000}
      maxDropdownHeight={320}
      styles={{
        input: {
          backgroundColor: COLOR_BACKGROUND_1,
          border: 'none',
          borderRadius: '20px',
          '::placeholder': {
            color: 'black',
          },
          height: isPC ? 40 : 36,
        },
        icon: {
          color: 'black',
        },
      }}
    />
  );
};
